import { Close } from '@mui/icons-material';
import {
  Alert,
  AppBar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Toolbar,
  Typography
} from '@mui/material';
import React, { Fragment, useState } from 'react';

// The photo viewer on its own, so a card can open it from its camera icon
// instead of rendering its own copy of the full-screen dialog.
export const ScorecardPhotoDialog = ({
  open,
  onClose,
  photoSrc,
  title = 'Scorecard',
  loading = false,
  error = ''
}) => (
  <Dialog open={open} onClose={onClose} fullScreen>
    <AppBar color="info" sx={{ position: 'relative' }}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
          <Close />
        </IconButton>
        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
          {title}
        </Typography>
        <Button autoFocus color="inherit" onClick={onClose}>
          Close
        </Button>
      </Toolbar>
    </AppBar>
    <DialogContent>
      <Box>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : !photoSrc ? (
          <Typography>No Scorecard</Typography>
        ) : (
          <img src={photoSrc} alt="Scorecard" width="100%" />
        )}
      </Box>
    </DialogContent>
  </Dialog>
);

const ViewScorecardPhoto = ({ game }) => {
  const [open, setOpen] = useState(false);
  // const [photoUrl, setPhotoUrl] = useState('');

  // useEffect(() => {
  //   console.log(game.scorecardPhoto);
  //   if (game.scorecardPhoto instanceof Blob) {
  //     const objectUrl = URL.createObjectURL(game.scorecardPhoto);
  //     setPhotoUrl(objectUrl);

  //     return () => {
  //       URL.revokeObjectURL(objectUrl); // Clean up the object URL
  //     };
  //   } else if (typeof game.scorecardPhoto === 'string') {
  //     setPhotoUrl(game.scorecardPhoto);
  //   } else {
  //     setPhotoUrl('');
  //   }
  // }, [game.scorecardPhoto]);

  return (
    <Fragment>
      <Button variant="contained" size="small" color="info" onClick={() => setOpen(true)}>
        View Scorecard
      </Button>

      <ScorecardPhotoDialog
        open={open}
        onClose={() => setOpen(false)}
        photoSrc={game.scorecardPhoto}
        title={`Scorecard for ${game.name || 'Private Game'}`}
      />
    </Fragment>
  );
};

export default ViewScorecardPhoto;
